import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import { AdminApi } from "../../api/AdminApi";

import {
    Box,
    Grid,
    Container,
    TextField,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    FormHelperText,
    Paper,
    Button,
    Stack,
} from "@mui/material";

import CommonBreadcrumb from "../../components/common/CommonBreadcrumb";
import FormContent from "../../components/dashboardVideo/dashboardVideoFormSchema.jsx";
import { isError, getErrorMsg, validateForm } from "../../helper/FormHelper.jsx";
import CommonImagePicker from "../../components/common/CommonImagePicker/CommonImagePicker.jsx";
import CommonOptionSelection from "../../components/common/CommonOptionSelection/CommonOptionSelection.jsx";
import VideoPreview from "../../components/common/VideoPreview/VideoPreview.jsx";

export default function Component() {
    const navigate = useNavigate();
    const formik = useFormik(FormContent.FormikInstance);
    const [thumbnailFile, setThumbnailFile] = useState(null);

    const handleCreate = async () => {
        if (await validateForm(formik)) return;
        let createData = JSON.parse(JSON.stringify(formik.values));

        // console.log("create dashboard video");
        if (!thumbnailFile) {
            toast.error("請上傳縮圖");
            return;
        }

        createData = {
            ...createData,
            thumbnail_file: thumbnailFile,
        };
        // 
        //        const createDashboardVideoCallback = async (formData, thumbnailFile, callback) => {
        // import { AdminApi } from "../../api/AdminApi";
        AdminApi.createDashboardVideoCallback(
            createData,
            (isSuccess, data) => {
                if (!isSuccess) {
                    return toast.error("新增失敗");
                }
                toast.success("新增成功");
                setTimeout(() => navigate("/dashboardVideos"), 1500);
            }
        );
    };

    return (
        <Container maxWidth={"lg"}>
            <CommonBreadcrumb />
            <Box component="form" sx={{ mt: 3 }}>
                <Paper sx={{ px: 3, py: 5 }} elevation={3}>
                    <Grid container rowSpacing={3} columnSpacing={2}>
                        {FormContent.FormControl.map((item, index) => {
                            const gridStyle = "size" in item ? item.size : { xs: 12 };
                            const formControlProps = item.props;

                            if (item.variant === "selector") {
                                return (
                                    <CommonOptionSelection key={`form-section-${index}`} item={item} formik={formik} />
                                );
                            }

                            if (item.variant === "youtube_link") {
                                return (
                                    <Grid item key={`form-section-${index}`} {...gridStyle}>
                                        <Stack spacing={1}>
                                            <TextField
                                                {...formControlProps}
                                                onBlur={formik.handleBlur}
                                                onChange={formik.handleChange}
                                                error={isError(formik, formControlProps.id)}
                                                helperText={getErrorMsg(formik, formControlProps.id)}
                                                fullWidth
                                            />
                                            <FormHelperText>請輸入 YouTube 連結 或 影片 URL</FormHelperText>
                                            {formik.values[formControlProps.id] && (
                                                <VideoPreview
                                                    url={formik.values[formControlProps.id]}
                                                    title={formControlProps.label}
                                                
                                                    showUrl={false}
                                                />
                                            )}
                                        </Stack>
                                    </Grid>
                                );
                            }

                            return (
                                <Grid item key={`form-section-${index}`} {...gridStyle}>
                                    <TextField
                                        {...formControlProps}
                                        onBlur={formik.handleBlur}
                                        onChange={formik.handleChange}
                                        error={isError(formik, formControlProps.id)}
                                        helperText={getErrorMsg(formik, formControlProps.id)}
                                        fullWidth
                                    />
                                </Grid>
                            );
                        })}



                        <Grid item xs={12}>
                            <CommonImagePicker
                                onChange={(file) => setThumbnailFile(file)}
                                onReset={() => setThumbnailFile(null)}
                                uploadCaption="上傳 Cover 縮圖"
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <Button variant="contained" onClick={handleCreate}>
                                新增
                            </Button>
                        </Grid>
                    </Grid>
                </Paper>
            </Box>
        </Container>
    );
}
